/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.general-listing[_ngcontent-%COMP%] {\n  color: #ffffff;\n  background: #9c0c2b;\n  font-style: oblique;\n  padding: 2px 10px 2px 10px;\n  border-radius: 5px; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvZW1wbG95ZWUvcGFnZXMvZW1wbG95ZWUtcG9zaXRpb25zL2VtcGxveWVlLXBvc2l0aW9ucy5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9EOi9pbmV0cHViL3d3d3Jvb3Qva2FpemVuLW5nL3NyYy9hcHAvbW9kdWxlcy9lbXBsb3llZS9wYWdlcy9lbXBsb3llZS1wb3NpdGlvbnMvZW1wbG95ZWUtcG9zaXRpb25zLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/$$_gendir/app/modules/employee/pages/employee-positions/employee-positions.component.scss.shim.ngstyle.ts